export default function ReportsPage() {
  return (
    <div>
      <h1 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#1a1c2c', marginBottom: '1rem' }}>
        📊 Reportes
      </h1>
      <p style={{ color: '#888' }}>Generación de reportes pendiente de implementación.</p>
    </div>
  );
}
